export const categories = [
  {
    name: 'Shoes',
    icon: 'ri-footprint-line',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneakers, boots, and footwear from top brands',
  },
  {
    name: 'Hoodies/Sweaters',
    icon: 'ri-t-shirt-line',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies and sweaters for every season',
  },
  {
    name: 'T-Shirts',
    icon: 'ri-shirt-line',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Graphic tees, basics, and designer t-shirts',
  },
  {
    name: 'Jackets',
    icon: 'ri-contrast-drop-line',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Bombers, varsity, denim, and winter jackets',
  },
  {
    name: 'Pants/Shorts',
    icon: 'ri-slideshow-line',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Jeans, cargos, sweatpants, and shorts',
  },
  {
    name: 'Headwear',
    icon: 'ri-glasses-line',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies, bucket hats, and more',
  },
  {
    name: 'Sets',
    icon: 'ri-stack-line',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Matching tracksuits and coordinated outfits',
  },
  {
    name: 'Underwear/Underpants',
    icon: 'ri-checkbox-multiple-blank-line',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Boxers, briefs, and essential undergarments',
  },
  {
    name: 'Jersey',
    icon: 'ri-football-line',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys from NBA, NFL, soccer, and more',
  },
  {
    name: 'Accessories',
    icon: 'ri-vip-diamond-line',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, jewelry, sunglasses, and more',
  },
  {
    name: 'Bags',
    icon: 'ri-briefcase-line',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, crossbody bags, and totes',
  },
  {
    name: 'Belts',
    icon: 'ri-link',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Designer belts, casual belts, and streetwear straps',
  },
  {
    name: 'Perfumes',
    icon: 'ri-drop-line',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer fragrances and niche colognes',
  },
  {
    name: 'Other Stuff',
    icon: 'ri-more-line',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Electronics, home goods, and everything else',
  },
];